export const getApiErrorMessage = (error: any): string => {
  return error?.response?.data?.error;
};
